import React from "react";
import Swal from "sweetalert2";
import scheduleService from "../../services/schedule.service";

const BtnEditSche = (props: { id: number; sche: any }) => {
  const { id, sche } = props;
  const onEdit = () => {
    Swal.fire({
      title: "คุณต้องการเปลี่ยนสถานะการรับเอกสาร?",
      text: `ปีการศึกษา ${sche.year} ภาคการศึกษาที่ ${sche.term}!`,
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "ใช่",
      cancelButtonText: "ยกเลิก",
    }).then((result) => {
      if (result.isConfirmed) {
        scheduleService.udpateStatus(id).then(() => {
          Swal.fire({
            position: "center",
            icon: "success",
            title: "บันทึกสำเร็จ",
            showConfirmButton: false,
            timer: 1500,
          }).then(() => {
            window.location.reload();
          });
        });
      }
    });
  };
  return (
    <>
      <button
        type="button"
        className="btn btn-sm btn-secondary text-white"
        onClick={onEdit}
      >
        <i className="bi bi-pencil-square"></i> สถานะรับเอกสาร
      </button>
    </>
  );
};

export default BtnEditSche;
